// extracted by mini-css-extract-plugin
export default {"label":"NumberInput_label__jfYV-","input":"NumberInput_input__Gcq-K","important":"NumberInput_important__rVfWX"};